import { render, staticRenderFns } from "./ContactSupportItem.vue?vue&type=template&id=3463ab88&scoped=true&"
import script from "./ContactSupportItem.vue?vue&type=script&lang=js&"
export * from "./ContactSupportItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463ab88",
  null
  
)

export default component.exports